<template>
  <div>
    <div class="mainLogoPosition text-center">
      <img src="@/assets/gregorys_logo.png" class="mb-3" style="width: 200px" />
    </div>
    <div v-if="emailVerifyGetter" class="introduction">
      <h1>{{ $translation('b2b_emailverify_title') }}</h1>
      <p v-if="emailVerifyGetter.status == 'success'">
        {{ $translation(emailVerifyGetter.message) }}
      </p>
      <p v-if="emailVerifyGetter.status == 'error'">
        {{ $translation(emailVerifyGetter.message) }}
      </p>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
export default {
  name: 'EmailVerify',
  computed: {
    ...mapGetters('data', ['emailVerifyGetter'])
  },
  created() {
    this.getEmailVerify(this.$route.params.hash);
  },
  methods: {
    ...mapActions('data', ['getEmailVerify'])
  }
};
</script>

<style lang="scss">
.introduction {
  text-align: center;

  h1 {
    font-weight: bold;
    font-size: 32px;
    line-height: 32px;
    margin-top: 0;
    margin-bottom: 22px;
  }

  p {
    font-size: 20px;
    width: 80%;
    margin: 0 auto 22px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/emailverify/index.vue